/* eslint-disable */
/*   OnlineOpinion v5.9.0 Released: 11/17/2014. Compiled 11/17/2014 01:01:01 PM -0600 Branch: master 7cffc7b9a0b11594d56b71ca0cb042d9b0fc24f5 Components: Full UMD: disabled The following code is Copyright 1998-2014 Opinionlab, Inc. All rights reserved. Unauthorized use is prohibited. This product and other products of OpinionLab, Inc. are protected by U.S. Patent No. 6606581, 6421724, 6785717 B1 and other patents pending. http://www.opinionlab.com    */ ;(function(
  a,
  b,
) {
  if ('disabled' === 'enabled' && typeof define === 'function' && define.amd) {
    define([], b)
  } else {
    a.OOo = b()
  }
})(window, function() {
  window.OOo = {
    __detectBrowser(a) {
      let b = Object.prototype.toString.call(window.opera) === '[object Opera]',
        d /*@cc_on=parseFloat((/MSIE[\s]*([\d\.]+)/).exec(navigator.appVersion)[1])@*/,
        c = {
          IE: !!d,
          Opera: b,
          WebKit: a.indexOf('AppleWebKit/') > -1,
          Chrome: a.indexOf('Chrome') > -1,
          Gecko: a.indexOf('Gecko') > -1 && a.indexOf('KHTML') === -1,
          MobileSafari: /Apple.*Mobile.*Safari/.test(a),
          iOs:
            a.indexOf('iPad') > -1 ||
            a.indexOf('iPhone') > -1 ||
            a.indexOf('iPod') > -1,
          iOS67: a.search(/OS 6(.*)|7(.*) like Mac OS/i) > -1,
          PalmPre: a.indexOf('Pre/') > -1,
          BlackBerry: a.indexOf('BlackBerry') > -1,
          Fennec: a.indexOf('Fennec') > -1,
          IEMobile: a.indexOf('IEMobile') > -1,
          OperaMobile: a.search(/Opera (?:Mobi|Mini)/) > -1,
          Kindle: a.search(/[ ](Kindle|Silk)/) > -1,
          isChromeIOS: /crios/i.test(navigator.userAgent),
          ua: a,
        },
        e = false
      c.isMobile =
        c.MobileSafari ||
        c.PalmPre ||
        c.BlackBerry ||
        c.Fennec ||
        c.IEMobile ||
        c.OperaMobile ||
        c.Kindle
      c.isMobileNonIOS =
        c.isMobile && (!c.MobileSafari || a.search('Android') !== -1)
      return c
    },
  }
  OOo.Browser = OOo.__detectBrowser(navigator.userAgent)
  OOo.Cache = {}
  OOo.instanceCount = 0
  OOo.K = function() {}
  var E = E || OOo
  ;(function() {
    function v(a) {
      return document.getElementById(a)
    }
    function w(a, b) {
      let d
      for (d in b) {
        if (b.hasOwnProperty(d)) {
          a[d] = b[d]
        }
      }
      return a
    }
    function x(a, b, d, c) {
      if (a.addEventListener) {
        a.addEventListener(b, d, c)
      } else if (a.attachEvent) {
        a.attachEvent('on' + b, d)
      }
    }
    function u(a, b, d, c) {
      if (a.removeEventListener) {
        a.removeEventListener(b, d, c)
      } else if (a.detachEvent) {
        a.detachEvent('on' + b, d)
      }
    }
    function D(a) {
      let b = [],
        d
      for (d in a) {
        if (a.hasOwnProperty(d)) {
          b.push(d + '=' + (encodeURIComponent(a[d]) || ''))
        }
      }
      return b.join('&')
    }
    function y(a) {
      let b = D(a.metrics),
        d =
          a.tealeafId +
          '|' +
          a.clickTalePID +
          '/' +
          a.clickTaleUID +
          '/' +
          a.clickTaleSID
      b += '&custom_var=' + OOo.createLegacyVars(a.legacyVariables, d)
      if (a.metrics.type === 'OnPage') {
        b += '|iframe'
      }
      if (a.asm) {
        b += '&asm=2'
      }
      b += '&_' + 'rev=2'
      if (a.customVariables) {
        b +=
          '&customVars=' + encodeURIComponent(OOo.serialize(a.customVariables))
      }
      return b
    }
    function A(a, b) {
      let d = document,
        c = d.createElement('form'),
        e = d.createElement('input'),
        f = a.referrerRewrite
      a.metrics.referer = location.href
      if (f) {
        a.metrics.referer = OOo.referrerRewrite(f)
      }
      c.style.display = 'none'
      c.method = 'post'
      c.target = b || 'OnlineOpinion'
      c.action = a.onPageCard
        ? 'https://secure.opinionlab.com/ccc01/comment_card_json_4_0_b.asp?r=' +
          location.href
        : 'https://secure.opinionlab.com/ccc01/comment_card_d.asp'
      if (a.commentCardUrl) {
        c.action = a.commentCardUrl
        if (a.onPageCard) {
          c.action += '?r=' + location.href
        }
      }
      e.name = 'params'
      e.value = y(a)
      c.appendChild(e)
      d.body.appendChild(c)
      return c
    }
    function z() {
      return {
        width: screen.width,
        height: screen.height,
        referer: location.href,
        prev: document.referrer,
        time1: new Date().getTime(),
        time2: null,
        currentURL: location.href,
        ocodeVersion: '5.9.0',
      }
    }
    function C(a) {
      let b = ''
      if (a && a.search('://') > -1) {
        let d = a.split('/')
        for (let c = 3; c < d.length; c++) {
          b += '/'
          b += d[c]
        }
      }
      return b
    }
    function B(a, b) {
      a = a || {}
      if (typeof a === 'string') {
        return b + '|' + a
      }
      return a.override ? a.vars : b + (a.vars ? '|' + a.vars : '')
    }
    function F(a, b) {
      if (!b) {
        b = location
      }
      if (typeof a === 'string') return a
      return a.searchPattern
        ? b.href.replace(a.searchPattern, a.replacePattern)
        : a.replacePattern
    }
    function N(a) {
      let b,
        d = false,
        c = document.getElementsByTagName('meta')
      if (c !== 'undefined') {
        for (b = 0; b < c.length; b += 1) {
          if (c[b].getAttribute('name') === a) {
            d = true
          }
        }
      }
      return d
    }
    let G = (function() {
      if (
        navigator.appName === 'Microsoft Internet Explorer' &&
        navigator.userAgent.search('MSIE 6') !== -1
      ) {
        return true
      }
      let a = document.body,
        b,
        d
      if (document.createElement && a && a.appendChild && a.removeChild) {
        b = document.createElement('iframe')
        d = false
        b.setAttribute('name', 'oo_test')
        b.style.display = 'none'
        a.appendChild(b)
        d = !document.getElementsByName('oo_test')[0]
        a.removeChild(b)
        return d
      }
      return null
    })()
    function H(a, b) {
      let d = a || window.event
      if (d.preventDefault && d.stopPropagation) {
        d.preventDefault()
        d.stopPropagation()
      } else {
        d.returnValue = false
      }
      let c = OOo.$('oo_waypoint_container'),
        e = c.parentNode
      e.removeChild(c)
      if (b) {
        b.focus()
      }
    }
    function I() {
      let a = OOo.$('oo_waypoint_prompt')
      if (a) {
        let b = OOo.$('oo_waypoint_container')
        this.showWaypoint(b)
        return
      }
      let d = window.XMLHttpRequest
          ? new XMLHttpRequest()
          : new window.ActiveXObject('Microsoft.XMLHTTP'),
        c = this,
        e = document.createElement('link'),
        f
      d.onreadystatechange = function() {
        if (d.readyState !== 4) {
          return
        }
        c.showWaypoint(d.responseText)
      }
      d.open(
        'GET',
        this.options.pathToAssets + this.options.waypointMarkup,
        true,
      )
      d.send(null)
    }
    function J(c) {
      let e = document,
        f = 0,
        g = typeof c === 'string' ? e.createElement('div') : c,
        h = e.createElement('div'),
        l,
        m,
        j,
        i,
        k = this.options,
        r = k.categories,
        n,
        o,
        p = e.activeElement
      h.id = 'oo_waypoint_overlay'
      g.id = 'oo_waypoint_container'
      g.style.visibility = 'hidden'
      if (typeof c === 'string') {
        g.innerHTML = c
        e.body.appendChild(g)
      }
      g.appendChild(h)
      if (k.companyLogo && k.companySlogan) {
        l = new Image()
        l.src = k.companyLogo
        l.alt = k.companySlogan
        OOo.$('oo_company_logo').appendChild(l)
        OOo.$('oo_waypoint_prompt').setAttribute('aria-label', k.companySlogan)
      }
      j = new Image()
      j.src = k.pathToAssets + 'oo_opinionlab_logo.png'
      j.alt = 'powered by OpinionLab'
      OOo.$('ol_brand_logo').children[0].appendChild(j)
      n = OOo.$('oo_close_prompt')
      for (let s in r) {
        if (r.hasOwnProperty(s)) {
          let q = document.createElement('a'),
            t = k.categories[s].icon
          q.className = 'waypoint_icon'
          q.href = '#'
          q.innerHTML =
            String(s).replace(/_/g, ' ') +
            '<span class="screen_reader">This will open a new window</span>'
          if (t && e.addEventListener) {
            q.style.backgroundImage = 'url(' + k.pathToAssets + t + ')'
            q.style.backgroundRepeat = 'no-repeat'
            q.style.backgroundPosition = 'left center'
            q.style.backgroundSize = '70px 50px'
            q.style.textAlign = 'left'
            q.style.paddingLeft = '90px'
          }
          if (typeof k.categories[s].oCode === 'string') {
            OOo.addEventListener(
              q,
              'click',
              (function(d) {
                return function(a) {
                  let b = a || window.event
                  window.open(
                    k.categories[d].oCode,
                    '_0',
                    'scrollbars=yes,location=yes,menubar=yes,resizable=yes',
                  )
                  OOo.hideWaypoint(b, p)
                }
              })(s),
              false,
            )
            q.onkeyup = (function(d) {
              return function(a) {
                let b = a || window.event
                if (b.keyCode !== 13) {
                  return
                }
                window.open(
                  k.categories[d].oCode,
                  '_0',
                  'scrollbars=yes,location=yes,menubar=yes,resizable=yes',
                )
                OOo.hideWaypoint(b, p)
              }
            })(s)
          } else {
            OOo.addEventListener(
              q,
              'click',
              (function(d) {
                return function(a) {
                  let b = a || window.event
                  OOo.Waypoint[d].show(b)
                  OOo.hideWaypoint(b, p)
                }
              })(s),
              false,
            )
            q.onkeyup = (function(d) {
              return function(a) {
                let b = a || window.event
                if (b.keyCode !== 13) {
                  return
                }
                OOo.Waypoint[d].show(b)
                OOo.hideWaypoint(b, p)
              }
            })(s)
          }
          f++
          OOo.$('waypoint_icons').appendChild(q)
        }
      }
      OOo.addEventListener(
        n,
        'click',
        function(a) {
          let b = a || window.event
          OOo.hideWaypoint(b, p)
        },
        false,
      )
      i = OOo.$('waypoint_icons').children
      o = i[0]
      o.onkeydown = function(a) {
        let b = a || window.event
        if (b.keyCode === 9) {
          if (b.shiftKey) {
            n.focus()
            return false
          }
        }
      }
      n.onkeyup = function(a) {
        let b = a || window.event
        if (b.keyCode !== 13) {
          return
        }
        OOo.hideWaypoint(b, p)
      }
      n.onkeydown = function(a) {
        let b = a || window.event
        if (b.keyCode === 9) {
          if (!b.shiftKey) {
            o.focus()
            return false
          }
        }
      }
      i[f - 1].className = 'waypoint_icon last'
      g.style.visibility = 'visible'
      g.style.display = 'block'
      h.className = 'no_loading'
      o.focus()
    }
    function K(a, b) {
      let d = a || window.event
      if (d.preventDefault && d.stopPropagation) {
        d.preventDefault()
        d.stopPropagation()
      } else {
        d.returnValue = false
      }
      OOo.$('oo_container').style.display = 'none'
      if (b) {
        b.focus()
      }
    }
    function L() {
      let a = OOo.$('oo_invitation_prompt')
      if (a) {
        let b = OOo.$('oo_container')
        this.showPrompt(b)
        return
      }
      let d = window.XMLHttpRequest
          ? new XMLHttpRequest()
          : new window.ActiveXObject('Microsoft.XMLHTTP'),
        c = this,
        e = document.createElement('link'),
        f
      d.onreadystatechange = function() {
        if (d.readyState !== 4) {
          return
        }
        c.showPrompt(d.responseText)
      }
      d.open('GET', this.options.pathToAssets + this.options.promptMarkup, true)
      d.send(null)
    }
    function M(d, c) {
      let e = document,
        f = typeof d === 'string' ? e.createElement('div') : d,
        g = e.createElement('div'),
        h,
        l,
        m,
        j,
        i = this.options,
        k,
        r,
        n,
        o,
        p = e.activeElement
      g.id = 'oo_invitation_overlay'
      f.id = 'oo_container'
      f.style.visibility = 'hidden'
      if (typeof d === 'string') {
        f.innerHTML = d
        e.body.appendChild(f)
      }
      f.appendChild(g)
      k = OOo.$('oo_launch_prompt')
      r = OOo.$('oo_no_thanks')
      n = OOo.$('oo_close_prompt')
      o = OOo.$('oo_company_logo')
      if (i.companyLogo && i.companySlogan) {
        h = new Image()
        h.src = i.companyLogo
        h.alt = i.companySlogan
        o.appendChild(h)
        OOo.$('oo_invitation_prompt').setAttribute(
          'aria-label',
          i.companySlogan,
        )
      }
      m = new Image()
      m.src = i.pathToAssets + 'oo_opinionlab_logo.png'
      m.alt = 'powered by OpinionLab'
      OOo.$('ol_brand_logo').children[0].appendChild(m)
      if (i.callBacks) {
        if (typeof i.callBacks.prompt === 'function') {
          i.callBacks.prompt()
        }
        if (typeof i.callBacks.yesClick === 'function') {
          OOo.addEventListener(
            k,
            'click',
            function() {
              i.callBacks.yesClick()
            },
            false,
          )
        }
        if (typeof i.callBacks.noClick === 'function') {
          OOo.addEventListener(
            r,
            'click',
            function() {
              i.callBacks.noClick()
            },
            false,
          )
        }
        if (typeof i.callBacks.closeClick === 'function') {
          OOo.addEventListener(
            n,
            'click',
            function() {
              i.callBacks.closeClick()
            },
            false,
          )
        }
      }
      OOo.addEventListener(k, 'click', c.bind(this), false)
      OOo.addEventListener(
        r,
        'click',
        function(a) {
          let b = a || window.event
          OOo.hidePrompt(b, p)
        },
        false,
      )
      OOo.addEventListener(
        n,
        'click',
        function(a) {
          let b = a || window.event
          OOo.hidePrompt(b, p)
        },
        false,
      )
      k.onkeyup = function(a) {
        let b = a || window.event
        if (b.keyCode !== 13) {
          return
        }
        c.bind(this)
      }.bind(this)
      k.onkeydown = function(a) {
        let b = a || window.event
        if (b.keyCode === 9) {
          if (b.shiftKey) {
            n.focus()
            return false
          }
        }
      }
      r.onkeyup = function(a) {
        let b = a || window.event
        if (b.keyCode !== 13) {
          return
        }
        OOo.hidePrompt(b, p)
      }
      n.onkeyup = function(a) {
        let b = a || window.event
        if (b.keyCode !== 13) {
          return
        }
        OOo.hidePrompt(b, p)
      }
      n.onkeydown = function(a) {
        let b = a || window.event
        if (b.keyCode === 9) {
          if (!b.shiftKey) {
            k.focus()
            return false
          }
        }
      }
      f.style.visibility = 'visible'
      f.style.display = 'block'
      g.className = 'no_loading'
      p.blur()
      k.focus()
    }
    w(OOo, {
      extend: w,
      toQueryString: D,
      addEventListener: x,
      $: v,
      appendOOForm: A,
      removeEventListener: u,
      createMetrics: z,
      truncateMetric: C,
      createLegacyVars: B,
      DYNAMIC_FRAME_NAME_IS_BUGGY: G,
      getFormParams: y,
      referrerRewrite: F,
      hidePrompt: K,
      getPrompt: L,
      showPrompt: M,
      hideWaypoint: H,
      getWaypoint: I,
      showWaypoint: J,
    })
  })()
  ;(function() {
    function f(a) {
      if (!a) {
        return null
      }
      switch (typeof a) {
        case 'number':
        case 'boolean':
        case 'function':
          return a
        case 'string':
          return "'" + a + "'"
        case 'object':
          var b, d, c, e
          if (a.constructor === Array || typeof a.callee !== 'undefined') {
            b = '['
            c = a.length
            for (d = 0; d < c - 1; d += 1) {
              b += f(a[d]) + ','
            }
            b += f(a[d]) + ']'
          } else {
            b = '{'
            for (e in a) {
              if (a.hasOwnProperty(e)) {
                b += e + ':' + f(a[e]) + ','
              }
            }
            b = b.replace(/\,$/, '') + '}'
          }
          return b
        default:
          return null
      }
    }
    OOo.extend(OOo, { serialize: f })
  })()
  ;(function() {
    function e(a, b, d) {
      let c
      if (a.search(b[0]) !== -1) {
        OOo.createCookie(d, 0)
        return false
      } else if (OOo.readCookie(d)) {
        c = parseInt(OOo.readCookie(d), 10)
        if (a.search(b[c + 1]) !== -1 && c + 1 !== b.length - 1) {
          OOo.createCookie(d, c + 1)
          return false
        } else if (a.search(b[c]) !== -1) {
          return false
        } else if (c + 1 === b.length - 1 && a.search(b.pop()) !== -1) {
          OOo.eraseCookie(d)
          return true
        }
        OOo.eraseCookie(d)
        return false
      }
      return false
    }
    OOo.extend(OOo, { checkTunnel: e })
  })()
  ;(function() {
    function p(a) {
      let b = '',
        d
      for (d = 7; d >= 0; d -= 1) {
        b += '0123456789abcdef'.charAt((a >> (d * 4)) & 0x0f)
      }
      return b
    }
    function s(a) {
      let b = ((a.length + 8) >> 6) + 1,
        d = new Array(b * 16),
        c
      for (c = 0; c < b * 16; c += 1) {
        d[c] = 0
      }
      for (c = 0; c < a.length; c += 1) {
        d[c >> 2] |= a.charCodeAt(c) << (24 - (c % 4) * 8)
      }
      d[c >> 2] |= 0x80 << (24 - (c % 4) * 8)
      d[b * 16 - 1] = a.length * 8
      return d
    }
    function q(a, b) {
      let d = (a & 0xffff) + (b & 0xffff),
        c = (a >> 16) + (b >> 16) + (d >> 16)
      return (c << 16) | (d & 0xffff)
    }
    function t(a, b) {
      return (a << b) | (a >>> (32 - b))
    }
    function v(a, b, d, c) {
      if (a < 20) {
        return (b & d) | (~b & c)
      }
      if (a < 40) {
        return b ^ d ^ c
      }
      if (a < 60) {
        return (b & d) | (b & c) | (d & c)
      }
      return b ^ d ^ c
    }
    function w(a) {
      return a < 20
        ? 1518500249
        : a < 40
          ? 1859775393
          : a < 60
            ? -1894007588
            : -899497514
    }
    function x(a) {
      let b = s(a),
        d = new Array(80),
        c = 1732584193,
        e = -271733879,
        f = -1732584194,
        g = 271733878,
        h = -1009589776,
        l,
        m,
        j,
        i,
        k,
        r,
        n,
        o
      for (n = 0; n < b.length; n += 16) {
        l = c
        m = e
        j = f
        i = g
        k = h
        for (o = 0; o < 80; o += 1) {
          if (o < 16) {
            d[o] = b[n + o]
          } else {
            d[o] = t(d[o - 3] ^ d[o - 8] ^ d[o - 14] ^ d[o - 16], 1)
          }
          r = q(q(t(c, 5), v(o, e, f, g)), q(q(h, d[o]), w(o)))
          h = g
          g = f
          f = t(e, 30)
          e = c
          c = r
        }
        c = q(c, l)
        e = q(e, m)
        f = q(f, j)
        g = q(g, i)
        h = q(h, k)
      }
      return p(c) + p(e) + p(f) + p(g) + p(h)
    }
    OOo.extend(OOo, { sha1: x })
  })()
  ;(function() {
    function h(a, b) {
      if (!b) {
        b = location
      }
      let d = a.cookieName || 'oo_abandon',
        c = OOo.readCookie(d),
        e = a.startPage,
        f = a.endPage,
        g = a.middle
      if (!c) {
        if (b.pathname.indexOf(e) !== -1) {
          OOo.createCookie(d)
        }
        return false
      } else if (b.pathname.indexOf(f) !== -1) {
        OOo.eraseCookie(d)
        return false
      } else if (b.pathname.search(g) !== -1) {
        return false
      }
      OOo.eraseCookie(d)
      return true
    }
    OOo.extend(OOo, { checkAbandonment: h })
  })()
  ;(function() {
    function c(a) {
      let b, d
      for (b = a.length - 1; b >= 0; b -= 1) {
        if (a[b].read) {
          d = OOo.readCookie(a[b].name)
          if (!!d && d === a[b].value) {
            return true
          } else if (
            typeof a[b].value === 'undefined' &&
            !!OOo.readCookie(a[b].name)
          ) {
            return true
          }
        }
      }
      return false
    }
    function e(a) {
      let b
      for (b = a.length - 1; b >= 0; b -= 1) {
        if (a[b].set) {
          OOo.createCookie(a[b].name, a[b].value, a[b].expiration)
        }
      }
    }
    OOo.extend(OOo, { checkThirdPartyCookies: c, setThirdPartyCookies: e })
  })()
  OOo.extend(
    Function.prototype,
    (function() {
      if (typeof Function.prototype.bind !== 'undefined') {
        return
      }
      let e = Array.prototype.slice
      function f(a, b) {
        let d = a.length,
          c = b.length
        while (c) {
          c -= 1
          a[d + c] = b[c]
        }
        return a
      }
      function g(a, b) {
        a = e.call(a, 0)
        return f(a, b)
      }
      function h(b) {
        if (arguments.length < 2 && typeof b === 'undefined') {
          return this
        }
        let d = this,
          c = e.call(arguments, 1)
        return function() {
          let a = g(c, arguments)
          return d.apply(b, a)
        }
      }
      return { bind: h }
    })(),
  )
  ;(function() {
    function f(a) {
      if (!a) {
        a = location
      }
      let b
      if (a.host.search(/\.[a-z]+/) !== -1) {
        b = a.host.split('.').reverse()
        if (b.length > 3) {
          return a.host
        }
        b = '.' + b[1] + '.' + b[0]
      } else {
        b = a.host
      }
      return b
    }
    function g(a, b, d) {
      let c = '',
        e = ''
      if (d) {
        c = new Date()
        c.setTime(c.getTime() + d * 1000)
        e = '; expires=' + c.toGMTString()
      }
      if (location.host !== f()) {
        document.cookie = a + '=' + b + e + '; path=/; domain=' + f() + ';'
      } else {
        document.cookie = a + '=' + b + e + '; path=/;'
      }
    }
    function h(a) {
      let b = a + '=',
        d = document.cookie.split(';'),
        c,
        e
      for (e = 0; e < d.length; e += 1) {
        c = d[e]
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length)
        }
        if (c.indexOf(b) === 0) {
          return c.substring(b.length, c.length)
        }
      }
      return null
    }
    function l(a) {
      g(a, '', -1)
    }
    OOo.extend(OOo, {
      getCookieDomain: f,
      createCookie: g,
      readCookie: h,
      eraseCookie: l,
    })
  })()
  OOo.Ocode = function(a) {
    let b = OOo.Browser,
      d,
      c
    if (a.disableMobile && b.isMobile) {
      return
    }
    if (a.disableNoniOS && b.isMobileNonIOS) {
      return
    }
    OOo.instanceCount += 1
    this.options = { tealeafCookieName: 'TLTSID' }
    OOo.extend(this.options, a)
    d = this.options
    d.metrics = OOo.createMetrics()
    this.frameName = d.onPageCard
      ? 'OnlineOpinion' + OOo.instanceCount
      : 'OnlineOpinion'
    if (d.cookie && OOo.Ocode.matchUrl(d.cookie, location)) {
      return
    }
    if (
      d.thirdPartyCookies &&
      OOo.checkThirdPartyCookies(d.thirdPartyCookies)
    ) {
      return
    }
    if (d.abandonment && !OOo.checkAbandonment(d.abandonment)) {
      return
    }
    if (
      d.tunnel &&
      !OOo.checkTunnel(location.pathname, d.tunnel.path, d.tunnel.cookieName)
    ) {
      return
    }
    if (d.events && d.events.onSingleClick) {
      this.singProbability = Math.random() < 1 - d.events.onSingleClick / 100
    }
    d.tealeafId =
      OOo.readCookie(d.tealeafCookieName) || OOo.readCookie(d.sessionCookieName)
    if (d.events) {
      this.setupEvents()
      if (d.events.disableLinks || d.events.disableFormElements) {
        this.setupDisableElements()
      }
    }
    if (d.floating) {
      this.floating()
    } else if (d.bar) {
      this.bar()
    } else if (d.tab) {
      this.tab()
    }
  }
  OOo.Ocode.prototype = {
    show(a, b) {
      let d = a || window.event
      if (b !== 'exit' && b !== 'entry') {
        if (d.preventDefault && d.stopPropagation) {
          d.preventDefault()
          d.stopPropagation()
        } else {
          d.returnValue = false
        }
      }
      if (this.onPageCardVisible) {
        return
      }
      let c = this.options,
        e
      if (c.events && c.events.prompt) {
        if (c.cookie) OOo.eraseCookie(c.cookie.name || 'oo_r')
        OOo.hidePrompt()
      }
      if (this.interruptShow) {
        return
      }
      if (!this.floatingLogo && c.cookie && OOo.Ocode.matchUrl(c.cookie)) {
        return
      }
      if (!c.floating && c.events && this.singProbability) {
        return
      }
      if (c.events && c.events.onSingleClick) {
        this.singProbability = true
      }
      if (c.cookie) {
        OOo.Ocode.tagUrl(c.cookie)
      }
      if (c.thirdPartyCookies) {
        if (OOo.checkThirdPartyCookies(c.thirdPartyCookies)) {
          return
        }
        OOo.setThirdPartyCookies(c.thirdPartyCookies)
      }
      if (this.floatingLogo) {
        this.floatingLogo.children[0].blur()
      }
      if (this.floatingLogo && c.disappearOnClick) {
        this.floatingLogo.style.display = 'none'
      }
      if (c.clickTalePID && typeof window.ClickTale === 'function') {
        c.clickTaleUID = window.ClickTaleGetUID()
        c.clickTaleSID = window.ClickTaleGetSID()
      }
      if (c.onPageCard && !OOo.Browser.isMobile) {
        this.setupOnPageCC()
      } else {
        this.launchOOPopup()
      }
      e = c.floating || c.tab || c.bar
      if (e && typeof e.onClickCallback === 'function') {
        e.onClickCallback()
      }
    },
  }
  OOo.extend(OOo.Ocode, {
    tagUrl(a, b) {
      if (!b) {
        b = location
      }
      let d = a.name || 'oo_r',
        c = a.type === 'page' ? b.href : b.hostname,
        e = OOo.readCookie(d) || ''
      if (OOo.Ocode.matchUrl(a, b)) {
        return
      }
      OOo.createCookie(d, e + OOo.sha1(c), a.expiration)
    },
    matchUrl(a, b) {
      if (!b) {
        b = location
      }
      let d = OOo.readCookie(a.name || 'oo_r'),
        c
      if (!d) {
        return false
      }
      c = a.type === 'page' ? b.href : b.hostname
      return d.search(OOo.sha1(c)) !== -1
    },
  })
  ;(function() {
    let l = 0
    function m() {
      let a = this.options,
        b = a.newWindowSize || [545, 325],
        d = [
          parseInt((a.metrics.height - b[1]) / 2, 10),
          parseInt((a.metrics.width - b[0]) / 2, 10),
        ],
        c,
        e,
        f =
          'resizable=yes,location=no,status=no,scrollbars=1,width=' +
          b[0] +
          ',height=' +
          b[1] +
          ',top=' +
          d[0] +
          ',left=' +
          d[1],
        g = 'OnlineOpinion'
      if (a.newWindow) {
        g = g + l++
      }
      a.metrics.time2 = new Date().getTime()
      a.metrics.type = 'Popup'
      c = OOo.appendOOForm(a, g)
      let h =
        'https://secure.opinionlab.com/ccc01/comment_card_d.asp?' +
        c.children[0].value
      if (a.commentCardUrl) {
        h = a.commentCardUrl
      }
      if (OOo.Browser.isChromeIOS) {
        g = '_0'
      }
      if (OOo.Browser.isMobile && OOo.Browser.ua.search('Android') !== -1) {
        c.submit()
      } else {
        e = window.open(h, g, f)
        if (e && !OOo.Browser.isChromeIOS) {
          c.submit()
        }
      }
    }
    OOo.extend(OOo.Ocode.prototype, { launchOOPopup: m })
  })()
  ;(function() {
    function i() {
      let d = this.options.events,
        c = [false, false],
        e = ['onExit', 'onEntry'],
        f = 'beforeunload',
        g,
        h,
        l,
        m,
        j
      if (OOo.Browser.Opera) {
        f = 'unload'
      }
      if (OOo.Browser.iOs) {
        f = 'pagehide'
      }
      if (d.prompt) {
        OOo.extend(this.options, {
          promptMarkup: d.prompt.promptMarkup || 'oo_event_prompt.html',
          neverShowAgainButton: false,
          pathToAssets: d.prompt.pathToAssets,
        })
      }
      for (l = e.length - 1; l >= 0; l -= 1) {
        g = e[l]
        if (d[g] instanceof Array) {
          m = d[g]
          j = m.length
          while (j && !c[l]) {
            j -= 1
            if (
              window.location.href.search(m[j].url) !== -1 &&
              Math.random() >= 1 - m[j].p / 100
            ) {
              c[l] = true
            }
          }
        } else if (d[g] && Math.random() >= 1 - d[g] / 100) {
          c[l] = true
        }
      }
      if (c[0]) {
        OOo.addEventListener(
          window,
          f,
          function(a) {
            let b = a || window.event
            this.show(b, 'exit')
          }.bind(this),
          false,
        )
      }
      if (c[1]) {
        if (d.delayEntry) {
          window.setTimeout(
            function(a) {
              let b = a || window.event
              if (d.prompt) {
                this.getPrompt()
              } else {
                this.show(b, 'entry')
              }
            }.bind(this),
            d.delayEntry * 1000,
          )
        } else if (d.prompt) {
          this.getPrompt()
        } else {
          ;(function(a) {
            let b = a || window.event
            this.show(b, 'entry')
          }.bind(this)())
        }
      }
    }
    function k(a) {
      let b = a || window.event,
        d = a.target || a.srcElement,
        c = this.options.events,
        e = d.parentNode,
        f = 5,
        g = 0
      while (e && (d.nodeName !== 'A' || d.nodeName !== 'INPUT') && g !== f) {
        if (e.nodeName === 'A') {
          d = e
        }
        e = e.parentNode
        g += 1
      }
      if (
        c.disableFormElements &&
        (d.tagName === 'INPUT' || d.tagName === 'BUTTON') &&
        (d.type === 'submit' ||
          d.type === 'image' ||
          d.type === 'reset' ||
          d.type === 'button')
      ) {
        this.interruptShow = true
      }
      if (
        c.disableLinks &&
        (d.nodeName === 'A' || d.nodeName === 'AREA') &&
        d.href.substr(0, 4) === 'http' &&
        d.href.search(c.disableLinks) !== -1
      ) {
        this.interruptShow = true
      }
    }
    function r(a) {
      this.interruptShow = true
    }
    function n() {
      OOo.addEventListener(document.body, 'mousedown', k.bind(this))
      if (!this.options.events.disableFormElements) {
        return
      }
      let a = document.getElementsByTagName('form'),
        b
      for (b = a.length - 1; b >= 0; b -= 1) {
        OOo.addEventListener(a[b], 'submit', r.bind(this))
      }
    }
    OOo.extend(OOo.Ocode.prototype, {
      setupEvents: i,
      setupDisableElements: n,
      getPrompt() {
        OOo.getPrompt.call(this)
      },
      showPrompt(a) {
        if (this.options.cookie) {
          OOo.Ocode.tagUrl(this.options.cookie)
        }
        OOo.showPrompt.call(this, a, this.show)
      },
    })
  })()
  OOo.extend(OOo.Ocode.prototype, {
    floating() {
      let c = document,
        e = (this.floatingLogo = document.createElement('div')),
        f = c.createElement('div'),
        g = c.createElement('div'),
        h = c.createElement('div'),
        l = c.createElement('span'),
        m = this.options.floating,
        j = OOo.$(m.contentId),
        i = '10px',
        k = m.id,
        r = c.createElement('span'),
        n,
        o,
        p,
        s,
        q,
        t,
        v,
        w,
        x = 0
      function u(a) {
        return a.offsetLeft + a.offsetWidth
      }
      function D(a) {
        s.style.left = u(j) + 'px'
      }
      r.innerHTML =
        'Screen reader users: Please switch to forms mode for this link.'
      r.className = 'screen_reader'
      if (k) {
        e.id = k
      }
      e.className = 'oo_feedback_float'
      g.className = 'oo_transparent'
      f.className = 'olUp'
      h.className = 'olOver'
      f.tabIndex = 0
      f.onkeyup = function(a) {
        n = a || window.event
        if (n.keyCode !== 13) {
          return
        }
        this.show(n)
      }.bind(this)
      f.innerHTML = m.caption || 'Feedback'
      e.appendChild(r)
      e.appendChild(f)
      l.innerHTML = m.hoverCaption || 'Click here to<br>rate this page'
      h.appendChild(l)
      e.appendChild(h)
      e.appendChild(g)
      function y(a) {
        let b = c.documentElement.scrollTop || c.body.scrollTop,
          d = c.documentElement.clientHeight || document.body.clientHeight
        e.style.top = b + d - (v || 0) - 10 + 'px'
      }
      if (OOo.Browser.MobileSafari) {
        if (OOo.Browser.ua.search('OS 4') !== -1) {
          o = window.innerHeight
          e.style.bottom = null
          e.style.top = window.pageYOffset + window.innerHeight - 60 + 'px'
          w = function(a) {
            p = window.pageYOffset - (o - window.innerHeight)
            e.style.webkitTransform = 'translateY(' + p + 'px)'
          }
          OOo.addEventListener(window, 'scroll', w, false)
          setTimeout(w, 100)
        }
      }
      if (m.position && m.position.search(/Content/) && j) {
        s = this.spacer = c.createElement('div')
        q = OOo.Browser.WebKit ? c.body : c.documentElement
        s.id = 'oo_feedback_fl_spacer'
        s.style.left = u(j) + 'px'
        c.body.appendChild(s)
        switch (m.position) {
          case 'rightOfContent':
            t = function(a) {
              e.style.left = u(j) - q.scrollLeft + 'px'
            }
            break
          case 'fixedPreserveContent':
            t = function(a) {
              let b = OOo.Browser.IE ? c.body.clientWidth : window.innerWidth,
                d = q.scrollLeft
              if (b <= u(j) + e.offsetWidth + parseInt(i, 10)) {
                e.style.left = u(j) - d + 'px'
              } else {
                e.style.left = ''
                e.style.right = i
              }
            }
            break
          case 'fixedContentMax':
            t = function(a) {
              let b = OOo.Browser.IE ? c.body.clientWidth : window.innerWidth
              if (b <= u(j) + e.offsetWidth + parseInt(i, 10)) {
                e.style.left = ''
                e.style.right = i
              } else {
                e.style.left = u(j) - q.scrollLeft + 'px'
                e.style.right = ''
              }
            }
            break
        }
        window.setTimeout(t, 0)
        OOo.addEventListener(window, 'scroll', t, false)
        OOo.addEventListener(window, 'resize', t, false)
        OOo.addEventListener(window, 'resize', D, false)
      } else {
        e.style.right = i
      }
      let A = function(a) {
        let b = a || window.event
        if (b.preventDefault && b.stopPropagation) {
          b.preventDefault()
          b.stopPropagation()
        } else {
          b.returnValue = false
        }
        x++
      }
      let z = function(a) {
        let b = a || window.event
        if (x >= 2) {
          this.show(b)
          x = 0
        }
      }.bind(this)
      if (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      ) {
        OOo.addEventListener(e, 'touchstart', A, false)
        OOo.addEventListener(e, 'touchend', z, false)
      } else {
        OOo.addEventListener(
          e,
          'click',
          function(a) {
            let b = a || window.event
            this.show(b)
          }.bind(this),
          false,
        )
      }
      c.body.appendChild(e)
    },
    removeFloatingLogo() {
      document.body.removeChild(this.floatingLogo)
      if (this.spacer) {
        document.body.removeChild(this.spacer)
      }
    },
  })
  OOo.extend(OOo.Ocode.prototype, {
    bar() {
      let c = document,
        e = (this.floatingLogo = c.createElement('a')),
        f,
        g,
        h,
        l = c.documentElement.scrollTop || c.body.scrollTop,
        m = c.createElement('span'),
        j = this.options,
        i = 0,
        k = c.createElement('span')
      function r(a) {
        let b = 0,
          d = 0
        if (a.offsetParent) {
          do {
            b += a.offsetLeft
            d += a.offsetTop
          } while (a == a.offsetParent)
          return [b, d]
        }
      }
      function n(a) {
        let b = document.activeElement,
          d
        if (!b) return
        d = r(b)
        if (!d) return
        if (
          d[1] + b.clientHeight >
          (window.innerHeight || document.body.clientHeight) +
            (window.pageYOffset || document.body.scrollTop) -
            e.clientHeight
        ) {
          if (navigator.appVersion.indexOf('MSIE 7.') !== -1) {
            window.scrollBy(0, 0)
          } else {
            window.scrollBy(0, b.clientHeight + 20)
          }
        }
      }
      m.innerHTML = 'Launches comment card in new window'
      m.className = 'screen_reader'
      k.className = 'icon'
      this.reflowBar = OOo.K
      e.id = 'oo_bar'
      e.href = '#'
      e.innerHTML = j.bar.caption || 'Feedback'
      e.appendChild(m)
      e.appendChild(k)
      if (typeof j.tabIndex === 'number') {
        e.tabIndex = j.tabIndex
      } else {
        e.tabIndex = 0
      }
      e.onkeyup = function(a) {
        let b = a || window.event
        if (b.keyCode !== 13) {
          return
        }
        this.show(b)
      }.bind(this)
      let o = function(a) {
        let b = a || window.event
        if (b.preventDefault && b.stopPropagation) {
          b.preventDefault()
          b.stopPropagation()
        } else {
          b.returnValue = false
        }
        i++
      }
      let p = function(a) {
        let b = a || window.event
        if (i >= 2) {
          this.show(b)
          i = 0
        }
      }.bind(this)
      if (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      ) {
        OOo.addEventListener(e, 'touchstart', o, false)
        OOo.addEventListener(e, 'touchend', p, false)
      } else {
        OOo.addEventListener(
          e,
          'click',
          function(a) {
            let b = a || window.event
            this.show(b)
          }.bind(this),
          false,
        )
      }
      document.body.className +=
        document.body.className < 1 ? 'oo_bar' : ' oo_bar'
      document.body.appendChild(e)
      if (OOo.Browser.MobileSafari && OOo.Browser.ua.search('OS 4') !== -1) {
        g = window.innerHeight
        e.style.bottom = null
        e.style.top = window.pageYOffset + window.innerHeight - 37 + 'px'
        f = function(a) {
          h = window.pageYOffset - (g - window.innerHeight)
          e.style.webkitTransform = 'translateY(' + h + 'px)'
        }
        OOo.addEventListener(window, 'scroll', f, false)
        setTimeout(f, 100)
      }
      OOo.addEventListener(document.body, 'keyup', n, false)
    },
  })
  OOo.extend(OOo.Ocode.prototype, {
    tab() {
      let d = document,
        c = (this.floatingLogo = d.createElement('div')),
        e = d.createElement('div'),
        f = d.createElement('div'),
        g = d.createElement('span'),
        h = this.options.tab,
        l = d.createElement('a'),
        m = 'Feedback',
        j = h.tabType,
        i = 'right',
        k = 0
      function r(a) {
        c.style.top =
          pageYOffset + (innerHeight / 2 - c.clientHeight / 2) + 'px'
        c.style.right =
          document.documentElement.clientWidth -
          window.innerWidth -
          window.pageXOffset -
          15 +
          'px'
      }
      switch (j) {
        case 1:
          var n = d.createElement('span')
          c = this.floatingLogo = d.createElement('a')
          e = d.createElement('span')
          c.href = '#'
          c.id = 'oo_tab_' + j
          if (h.position) {
            i = h.position
          }
          c.className = tabClass = 'oo_tab_' + i + '_' + j
          e.className = 'screen_reader'
          n.className = 'icon'
          if (typeof h.tabIndex === 'number') {
            c.tabIndex = h.tabIndex
          } else {
            c.tabIndex = 0
          }
          if (h.verbiage) {
            m = h.verbiage
          }
          c.innerHTML = m
          e.innerHTML = 'Launches comment card in new window'
          c.appendChild(e)
          c.appendChild(n)
          setTimeout(function() {
            c.className += ' small'
          }, 2500)
          break
        default:
          c.id = 'oo_tab'
          c.className = 'oo_tab_' + (h.position || i)
          if (h.wcagBasePath) {
            c.className += ' wcag'
          }
          if (typeof h.tabIndex === 'number') {
            c.tabIndex = h.tabIndex
          } else if (typeof h.tabIndex === 'undefined') {
            c.tabIndex = 0
          }
          f.appendChild(l)
          c.appendChild(f)
          f.appendChild(g)
          c.appendChild(f)
          if (e) {
            e.className = 'screen_reader'
            e.innerHTML = 'Activate to launch comment card'
            c.appendChild(e)
          }
          if (
            OOo.Browser.MobileSafari &&
            OOo.Browser.ua.search('OS 4') !== -1
          ) {
            c.style.position = 'absolute'
            OOo.addEventListener(window, 'scroll', r, false)
            setTimeout(r, 100)
          }
      }
      c.onkeyup = function(a) {
        let b = a || window.event
        if (b.keyCode !== 13) {
          return
        }
        this.show(b)
      }.bind(this)
      let o = function(a) {
        let b = a || window.event
        if (b.preventDefault && b.stopPropagation) {
          b.preventDefault()
          b.stopPropagation()
        } else {
          b.returnValue = false
        }
        k++
      }
      let p = function(a) {
        let b = a || window.event
        if (k >= 2) {
          this.show(b)
          k = 0
        }
      }.bind(this)
      if (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      ) {
        OOo.addEventListener(c, 'touchstart', o, false)
        OOo.addEventListener(c, 'touchend', p, false)
      } else {
        OOo.addEventListener(
          c,
          'click',
          function(a) {
            let b = a || window.event
            this.show(b)
          }.bind(this),
          false,
        )
      }
      d.body.appendChild(c)
    },
  })
  OOo.extend(OOo.Ocode.prototype, {
    setupOnPageCC() {
      let e = document,
        f = OOo.Cache.overlay || e.createElement('div'),
        g = (this.wrapper = e.createElement('div')),
        h = e.createElement('a'),
        l = e.createElement('div'),
        m = e.createElement('span'),
        j = this.frameName,
        i = e.createElement(
          OOo.DYNAMIC_FRAME_NAME_IS_BUGGY
            ? '<iframe name="' + j + '">'
            : 'iframe',
        ),
        k = e.createDocumentFragment(),
        r = this.options,
        n = r.onPageCard,
        o = 'https://secure.opinionlab.com/ccc01/comment_card_json_4_0_b.asp',
        p,
        s,
        q,
        t = false,
        v = this,
        w,
        x,
        u,
        D,
        y,
        A,
        z,
        C = e.createElement('span')
      function B(a) {
        if (a && a.preventDefault) {
          a.preventDefault()
        }
        document.body.focus()
        i.tabIndex = -1
        i.title = 'empty'
        i['aria-hidden'] = 'true'
        f.style.display = 'none'
        f.className = ''
        e.body.removeChild(g)
        if (window.postMessage) {
          OOo.removeEventListener(window, 'message', y)
        } else {
          window.clearInterval(s)
        }
        t = false
        v.onPageCardVisible = false
        return false
      }
      y = OOo.Ocode.postMessageHandler(function(a) {
        let b = parseInt(a, 10),
          d,
          c
        if (b > 0) {
          if (t) {
            return
          }
          t = true
          d =
            window.innerHeight ||
            e.documentElement.clientHeight ||
            e.body.clientHeight
          c = b
          z = g.offsetTop
          if (c + z > d) {
            c = d - 40 - z
          }
          i.style.width = '555px'
          l.style.width = '555px'
          i.style.height = c + 'px'
          g.style.visibility = 'visible'
          if (m.clientHeight < 20) {
            m.style.height = g.offsetHeight + 'px'
          }
          f.className = 'no_loading'
          v.onPageCardVisible = true
          p && e.body.removeChild(p)
        } else if (a === 'submitted') {
          B()
        }
        if (OOo.Browser.IE && e.compatMode === 'BackCompat') {
          window.scrollTo(0, 0)
        }
      }, v.options.commentCardUrl)
      r.metrics.type = 'OnPage'
      OOo.Cache.overlay = f
      f.id = 'oo_overlay'
      f.style.display = 'block'
      f.className = ''
      l.className = 'iwrapper'
      g.className = 'oo_cc_wrapper'
      g.setAttribute('role', 'alert')
      g.setAttribute('aria-describedby', 'comment_card_description')
      C.className = 'screen_reader'
      C.id = 'comment_card_description'
      C.innerHTML =
        'Please leave your feedback in the comment card you just activated'
      g.appendChild(C)
      h.className = 'oo_cc_close'
      h.innerHTML =
        '<span class="screen_reader">Close dialog</span><span aria-hidden="true">&#10006;</span>'
      h.title = r.closeTitle ? r.closeTitle : 'Close dialog'
      if (!e.addEventListener) {
        l.style.outline = '1px solid #cdcdcd'
      }
      g.style.visibility = 'hidden'
      h.tabIndex = 0
      h.onkeyup = function(a) {
        let b = a || window.event
        if (b.keyCode !== 13) {
          return
        }
        B()
      }
      if (OOo.Browser.IE) {
        i.frameBorder = '0'
        if (!window.XMLHttpRequest || e.compatMode === 'BackCompat') {
          A = Math.max(e.documentElement.clientWidth, e.body.offsetWidth)
          f.style.position = 'absolute'
          f.style.width =
            e.compatMode === 'BackCompat' ? A - 21 + 'px' : A + 'px'
          f.style.height =
            Math.max(e.documentElement.clientHeight, e.body.offsetHeight) + 'px'
          g.style.position = 'absolute'
          OOo.addEventListener(window, 'scroll', function() {
            f.style.top =
              e.body.scrollTop +
              document.body.clientHeight -
              f.clientHeight +
              'px'
            g.style.top = e.body.scrollTop + z + 25 + 'px'
          })
        }
      }
      OOo.addEventListener(h, 'click', B)
      if (n.closeWithOverlay && !OOo.Browser.isMobile) {
        g.appendChild(m)
        m.onclick = B
        f.onclick = B
      }
      i.src = ' '
      i.name = j
      i.title = 'Comment Card'
      l.appendChild(h)
      l.appendChild(i)
      g.appendChild(l)
      k.appendChild(g)
      k.appendChild(f)
      e.body.appendChild(k)
      if (window.postMessage) {
        OOo.addEventListener(window, 'message', y)
      } else {
        s = setInterval(y, 500)
      }
      r.metrics.time2 = new Date().getTime()
      p = OOo.appendOOForm(r, j)
      p.submit()
    },
  })
  OOo.extend(OOo.Ocode, {
    postMessageHandler(c, e, f) {
      return function(a) {
        let b = 'https://secure.opinionlab.com',
          d
        if (!f) {
          f = location
        }
        if (
          (a && !(a.origin === b || a.origin.indexOf(e) !== 0)) ||
          (!a && f.hash.search('OL=') === -1)
        ) {
          return false
        }
        d = a ? a.data : f.hash.split('=').pop()
        if (!a && location.hash) {
          location.hash = ''
        }
        c(d)
        return d
      }
    },
  })
  OOo.Invitation = function(a) {
    this.options = {
      tunnelCookie: 'oo_inv_tunnel',
      repromptTime: 604800,
      responseRate: 50,
      repromptCookie: 'oo_inv_reprompt',
      promptMarkup: 'oo_inv_prompt.html',
      promptStyles: 'oo_inverstitial_style.css',
      percentageCookie: 'oo_inv_percent',
      pagesHitCookie: 'oo_inv_hit',
      popupType: 'popunder',
      promptDelay: 0,
      neverShowAgainButton: false,
      loadPopupInBackground: false,
      truncatePrevCurrentMetrics: false,
      disablePrevCurrentMetrics: false,
      tealeafCookieName: 'TLTSID',
      monitorWindow: 'oo_inv_monitor.html',
      companySlogan: 'We value your opinion',
      beforePrompt: OOo.K,
      callBacks: { prompt: '', yesClick: '', noClick: '', closeClick: '' },
    }
    this.popupShown = false
    OOo.extend(this.options, a)
    let b = this.options,
      d = parseInt(OOo.readCookie(b.pagesHitCookie), 10) || 0
    OOo.Invitation.friendlyDomains = b.friendlyDomains || null
    let c = {
      weight: Number(OOo.readCookie('oo_OODynamicRewrite_weight')),
      searchPattern: OOo.readCookie('oo_OODynamicRewrite_searchPattern'),
      replacePattern: OOo.readCookie('oo_OODynamicRewrite_replacePattern'),
    }
    OOo.eraseCookie('oo_OODynamicRewrite_weight')
    OOo.eraseCookie('oo_OODynamicRewrite_searchPattern')
    OOo.eraseCookie('oo_OODynamicRewrite_replacePattern')
    if (
      !window.OOoDynamicRewrite ||
      window.OOoDynamicRewrite.weight < c.weight
    ) {
      window.OOoDynamicRewrite = c
    }
    if (
      window.OOoDynamicRewrite &&
      typeof window.OOoDynamicRewrite.weight === 'number' &&
      !isNaN(window.OOoDynamicRewrite.weight)
    ) {
      OOo.createCookie(
        'oo_OODynamicRewrite_weight',
        window.OOoDynamicRewrite.weight,
      )
      if (window.OOoDynamicRewrite.searchPattern) {
        OOo.createCookie(
          'oo_OODynamicRewrite_searchPattern',
          window.OOoDynamicRewrite.searchPattern,
        )
      }
      if (window.OOoDynamicRewrite.replacePattern) {
        OOo.createCookie(
          'oo_OODynamicRewrite_replacePattern',
          window.OOoDynamicRewrite.replacePattern,
        )
      }
    }
    if (
      location.search.search('evs') !== -1 ||
      OOo.readCookie('oo_evs_friendly') === 'yes'
    ) {
      OOo.eraseCookie('oo_evs_friendly')
      b.loadPopupInBackground = true
      this.launchPopup()
      OOo.createCookie(
        b.repromptCookie,
        1,
        b.repromptTime === -1 ? 0 : b.repromptTime,
      )
    }
    setTimeout(
      function() {
        if (!window.oo_inv_monitor) {
          return
        }
        if (b.area && location.href.search(b.area) === -1) {
          this.options.popupType = 'popup'
          this.launchPopup()
        } else if (b.goal && location.href.search(b.goal) !== -1) {
          window.oo_inv_monitor.close()
        }
      }.bind(this),
      1600,
    )
    if (OOo.readCookie(b.repromptCookie)) {
      return
    }
    if (
      b.thirdPartyCookies &&
      OOo.checkThirdPartyCookies(b.thirdPartyCookies)
    ) {
      return
    }
    if (!OOo.readCookie(b.percentageCookie)) {
      OOo.createCookie(
        b.percentageCookie,
        Math.random() > 1 - b.responseRate / 100 ? '1' : '0',
      )
    }
    if (typeof b.promptTrigger !== 'undefined') {
      if (b.promptTrigger instanceof RegExp) {
        if (!window.location.href.match(b.promptTrigger)) {
          return
        }
      } else if (b.promptTrigger instanceof Array) {
        if (
          !OOo.checkTunnel(location.pathname, b.promptTrigger, b.tunnelCookie)
        ) {
          return
        }
      }
    }
    d += 1
    OOo.createCookie(b.pagesHitCookie, d)
    if (b.pagesHit && d < b.pagesHit) {
      return
    }
    OOo.eraseCookie(b.tunnelCookie)
    if (OOo.readCookie(b.percentageCookie) === '1') {
      window.setTimeout(
        function() {
          OOo.createCookie(b.repromptCookie, 1, b.repromptTime)
          this.options.beforePrompt()
          this.getPrompt()
        }.bind(this),
        b.promptDelay * 1000,
      )
    }
  }
  OOo.Invitation.notifyFriendlyLocationChange = function(a) {
    if (window.oo_inv_monitor) {
      OOo.createCookie('oo_evs_friendly', 'yes')
    }
  }
  OOo.Invitation.prototype = {
    getPrompt() {
      OOo.getPrompt.call(this)
    },
    showPrompt(a) {
      OOo.showPrompt.call(this, a, this.launchPopup)
    },
    launchPopup(b) {
      if (this.popupShown) {
        return
      }
      this.popupShown = true
      let d = b || window.event
      if (d.preventDefault && d.stopPropagation) {
        d.preventDefault()
        d.stopPropagation()
      } else {
        d.returnValue = false
      }
      let c = this.options,
        e = window.location.href,
        f =
          c.popupType === 'popup'
            ? 'https://secure.opinionlab.com/ccc01/comment_card.asp?'
            : c.pathToAssets +
              c.monitorWindow +
              '?time1=' +
              new Date().getTime() +
              '&',
        g,
        h = [],
        l = c.asm ? [555, 500] : OOo.Browser.Chrome ? [400, 400] : [400, 350],
        m,
        j = OOo.createMetrics(),
        i = OOo.readCookie(c.tealeafCookieName),
        k
      if (c.clickTalePID && window.ClickTaleGetUID && window.ClickTaleGetSID) {
        i +=
          '|' +
          [
            c.clickTalePID,
            window.ClickTaleGetUID(),
            window.ClickTaleGetSID(),
          ].join('/')
      }
      l = c.newWindowSize || l
      k =
        'scrollbars=1,resizable=1,location=no,status=no,width=' +
        l[0] +
        ',height=' +
        l[1]
      if (c.referrerRewrite) {
        j.referer = OOo.referrerRewrite(c.referrerRewrite)
      }
      if (c.truncatePrevCurrentMetrics) {
        j.prev = OOo.truncateMetric(j.prev)
        j.currentURL = OOo.truncateMetric(j.currentURL)
      }
      if (c.disablePrevCurrentMetrics) {
        j.prev = ''
        j.currentURL = ''
      }
      if (c.thirdPartyCookies) {
        OOo.setThirdPartyCookies(c.thirdPartyCookies)
      }
      g = OOo.toQueryString(j) + '&type=Invitation'
      if (c.customVariables) {
        g +=
          '&customVars=' + encodeURIComponent(OOo.serialize(c.customVariables))
      }
      g += '&custom_var=' + OOo.createLegacyVars(c.legacyVariables, i)
      if (c.asm) {
        g += '&asm=2'
        k += ',scrollbars=1'
      }
      f += g
      if (f.match(/\?/g).length === 2) f = f.replace(/\?([^?]*)$/, '&$1')
      this.popup = m = window.open(f, 'OnlineOpinionInvitation', k)
      if (!c.loadPopupInBackground && OOo.$('oo_container')) {
        OOo.hidePrompt(d)
      }
      if (c.chromeSurveyPrompt) {
        setTimeout(function(a) {
          m.postMessage(c.chromeSurveyPrompt, '*')
        }, 500)
      }
    },
    killPrompt(a) {
      let b = a || window.event
      if (
        this.options.callBacks &&
        typeof this.options.callBacks.noClick === 'function'
      ) {
        this.options.callBacks.noClick()
      }
      OOo.createCookie(this.options.repromptCookie, 1, 157680000)
      OOo.hidePrompt(b)
    },
  }
  OOo.extend(OOo.Invitation, {
    navigateToFriendlyDomain(a) {
      location.href = a
    },
  })
  OOo.Waypoint = function(a) {
    let b = OOo.Browser
    if (a.disableMobile && b.isMobile) {
      return
    }
    if (a.disableNoniOS && b.isMobileNonIOS) {
      return
    }
    this.options = {
      pathToAssets: '/onlineopinionV5/',
      waypointMarkup: 'oo_waypoint.html',
      companySlogan: 'Give us feedback',
      companyLogo: 'waypoint_logo.png',
      categories: {
        website: {
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
        },
        store: {
          referrerRewrite: {
            searchPattern: /:\/\//,
            replacePattern: '://store.',
          },
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
        },
        product: {
          referrerRewrite: {
            searchPattern: /:\/\//,
            replacePattern: '://product.',
          },
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
        },
        other: {
          referrerRewrite: {
            searchPattern: /:\/\//,
            replacePattern: '://other.',
          },
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
        },
      },
    }
    OOo.extend(this.options, a)
    let d = this.options,
      c = d.categories
    for (let e in c) {
      if (c.hasOwnProperty(e)) {
        if (typeof d.categories[e].oCode === 'object') {
          let f = {}
          f[e] = new OOo.Ocode(c[e].oCode)
          OOo.extend(OOo.Waypoint, f)
        }
      }
    }
    OOo.extend(OOo.Waypoint, {
      getWaypoint: function() {
        this.getWaypoint()
      }.bind(this),
    })
  }
  OOo.Waypoint.prototype = {
    getWaypoint() {
      OOo.getWaypoint.call(this)
    },
    showWaypoint(a) {
      OOo.showWaypoint.call(this, a)
    },
    killWaypoint(a) {
      let b = a || window.event
      OOo.hideWaypoint(b)
    },
  }
  OOo.extend(OOo, {
    appendWaypoint(d) {
      let c = OOo.$(d)
      if (c) {
        OOo.addEventListener(
          c,
          'click',
          function(a) {
            let b = a || window.event
            if (b.preventDefault && b.stopPropagation) {
              b.preventDefault()
              b.stopPropagation()
            } else {
              b.returnValue = false
            }
            OOo.Waypoint.getWaypoint()
          },
          false,
        )
        OOo.addEventListener(
          c,
          'keydown',
          function(a) {
            let b = a || window.event
            if (b.preventDefault && b.stopPropagation) {
              b.preventDefault()
              b.stopPropagation()
            } else {
              b.returnValue = false
            }
            if (b.keyCode !== 13) {
              return
            }
            OOo.Waypoint.getWaypoint()
          },
          false,
        )
      }
    },
  })
  return OOo
})
